import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest} from "@api/ApiService";
import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {FinalizationFormResponse} from "@lib/Finalization/FinalizationFormTypes";

const ROUTE = {
    path: API_ROUTES.GET_SSO_FINALIZATION_FORM,
    module: API_MODULES.CORE_USER,
    solution: API_SOLUTIONS.MZ,
};

class FinalizationFormService {

    static getForm = async (): Promise<FinalizationFormResponse> => {
        const url = generateApiEndpoint(ROUTE);
        return getRequest<FinalizationFormResponse>(url);
    };

}

export default FinalizationFormService;